import { render, staticRenderFns } from "./ccv-donut-chart.vue?vue&type=template&id=4b5bc396&"
import script from "./ccv-donut-chart.vue?vue&type=script&lang=js&"
export * from "./ccv-donut-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports